"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ConcernForm = void 0;
var _zod = require("@hookform/resolvers/zod");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _reactHookForm = require("react-hook-form");
var _components = require("../../components");
var _constants = require("../../constants");
var _concernFormContext = require("../../contexts/concernFormContext");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _components2 = require("./components");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const ConcernForm = ()=>{
    const { concernFormData, concernFormConfig } = (0, _concernFormContext.useConcernForm)();
    const { getTestId } = (0, _testidGenerator.default)();
    const { validationSchema } = (0, _hooks.useFormValidation)({
        concernFormData,
        concernFormConfig
    });
    const form = (0, _reactHookForm.useForm)({
        resolver: (0, _zod.zodResolver)(validationSchema),
        defaultValues: _constants.initialFormValues
    });
    const { onSubmitHandler } = (0, _utils.useConcernFormAction)();
    if (concernFormData.questions.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        "data-testid": getTestId(_constants2.CONCERN_FORM),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Introduction, {
                title: concernFormData.introductionTitle,
                text: concernFormData.introduction
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_mui.Typography, {
                color: "textPrimary",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.RequiredSign, {}),
                    concernFormData.required
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactHookForm.FormProvider, {
                ...form,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Box, {
                    noValidate: true,
                    component: "form",
                    autoComplete: "off",
                    onSubmit: form.handleSubmit(onSubmitHandler),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_mui.Stack, {
                        spacing: 6,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components2.FormContent, {}),
                            concernFormConfig.recaptchaEnabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.FormRecaptchaField, {
                                id: _models.ConcernFormFields.Recaptcha,
                                siteKey: concernFormConfig.siteKey
                            }) : null,
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.FormSubmit, {
                                isSubmitting: form.formState.isSubmitting
                            })
                        ]
                    })
                })
            })
        ]
    });
};
exports.ConcernForm = ConcernForm;
